import { AccessControlResourcePatchRequest, AccessControlResourceResponse } from '@futrli-sdk/predict';
import { API_PATHS, interpolatePathParams, REQUEST_METHODS, ROUTE_PARAMS } from '@futrli/shared-services';

import { makeRequestWithResponse } from './shared';

export type OrganisationSharingEntityType = 'forecast' | 'live-report' | 'report-template';
export type ConsolidationSharingEntityType = 'consolidated-forecast' | 'live-report' | 'report-template';
export type SharingEntityType = OrganisationSharingEntityType | ConsolidationSharingEntityType;

export interface AccessControlResourceResponseWithEntityType extends AccessControlResourceResponse {
  readonly entity_type: SharingEntityType;
}

const getResourcePermissionsPath = (
  workspaceId: string,
  organisationId: string,
  entityType: SharingEntityType,
  entityId: string,
  isConsolidation: boolean
): string =>
  interpolatePathParams(
    isConsolidation ? API_PATHS.RESOURCE_PERMISSIONS_BY_ENTITY_CONSOLIDATION : API_PATHS.RESOURCE_PERMISSIONS_BY_ENTITY,
    {
      [ROUTE_PARAMS.ENTITY_ID]: entityId,
      [ROUTE_PARAMS.ENTITY_TYPE]: entityType,
      [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
      [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId
    }
  );

export const getResourcePermissions = async (
  workspaceId: string,
  organisationId: string,
  entityType: SharingEntityType,
  entityId: string,
  isConsolidation = false
): Promise<AccessControlResourceResponseWithEntityType> => {
  const path = getResourcePermissionsPath(workspaceId, organisationId, entityType, entityId, isConsolidation);

  return makeRequestWithResponse<AccessControlResourceResponseWithEntityType>({
    url: path,
    method: REQUEST_METHODS.GET
  });
};

export const updateResourcePermissions = async (
  workspaceId: string,
  organisationId: string,
  entityType: SharingEntityType,
  entityId: string,
  data: Partial<AccessControlResourcePatchRequest>,
  isConsolidation = false
): Promise<AccessControlResourceResponseWithEntityType> => {
  const path = getResourcePermissionsPath(workspaceId, organisationId, entityType, entityId, isConsolidation);

  return makeRequestWithResponse<AccessControlResourceResponseWithEntityType>({
    data,
    url: path,
    method: REQUEST_METHODS.PATCH
  });
};
